import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../components/MaterialInput";
import MaterialBox from "../../components/MaterialBox";
import MaterialButton from "../../components/MaterialButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonBadgeFill } from "react-icons/bs";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import URL from "../Utils/url";
import { fromGlobalId } from "../../lib/decoded/rawPk";
import axios from "axios";
import MaterialSelect from "../../components/MasterSelect";
import {
  GetUserDetailsQuery,
  getWarehousedetail,
} from "../../lib/graphQL/graphQuery";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  addWarehouseRestService,
  addWarehouseService,
  DeleteWareHouseService,
  updateWarehouseRestService,
  updateWarehouseService,
} from "../../lib/appUtliz/WarehouseService";
import SuccessPop from "../../Popup/SuccessPop";
import { useLoading } from "../../context/LodingContext";
import { useSuccess } from "../../context/SucccessContext";
import { useError } from "../../context/ErrorContext";

const UOMDetails = gql`
  query allUOM {
    allUom {
      id
      user {
        id
        email
        username
      }
      uomName
      uomAbbreviation
      decimalPlaces
      roundOff
      baseUnit
      baseUnitValue
      status
      lastUpdate
    }
  }
`;

const brandDetails = gql`
  query {
    allBrandDetail {
      id
      user {
        id
        username
        email
      }
      brandLogo
      brandName
      status
      lastUpdate
    }
  }
`;
export default function AddWareHouse() {
  const [selectedData, setSelectedData] = useState([]);
  const [isFocused, setIsFocused] = useState(null);
  const [uomDropDown, setuomDropDown] = useState([]);
  const [brandDropDown, setBrandDropDwon] = useState([]);
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [pendingLoading, setPendingLoading] = useState(false);
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus } = useError();

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });
  const [wareHouseData, setWareHouseData] = useState({
    // WareHouse Details
    wareHouseName: "",
    category: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    supervisorName: "",
    supervisorNumber: "",
    wareHouseContactNumber: "",
    wareHouseCapacity: "",
    capacityUOM: "",
    description: "",
    brandName: "",
    warehouseCost: "",
    sellingPrice: "",
    SKU: "",
    uomName: "",
    reorderLevel: "",
    Tax: "",
    warehouseImage: "",
    HSNNumber: "",
    previewURL: "",
    // Uom Type Status
    reorderLevelStatus: "unchecked",
    TaxStatus: "unchecked",
    warehouseImageStatus: "unchecked",
    SKUStatus: "unchecked",
    uomNameStatus: "unchecked",
    HSNNumberStatus: "unchecked",
    sellingPriceStatus: "unchecked",
    warehouseCostStatus: "unchecked",
    brandNameStatus: "unchecked",
    wareHouseNameStatus: "unchecked",
    categoryStatus: "unchecked",
    addressLine1Status: "unchecked",
    addressLine2Status: "unchecked",
    countryStatus: "unchecked",
    stateStatus: "unchecked",
    cityStatus: "unchecked",
    zipCodeStatus: "unchecked",
    supervisorNameStatus: "unchecked",
    supervisorNumberStatus: "unchecked",
    wareHouseContactNumberStatus: "unchecked",
    wareHouseCapacityStatus: "unchecked",
    capacityUOMStatus: "unchecked",
    descriptionStatus: "unchecked",
    warehouseImageStatus: "unchecked",
  });

  const { currentUser } = useAuth();
  const { id: rawPk } = fromGlobalId(currentUser?.id);
  const [supervisorData, setSupervisorData] = useState([]);

  useEffect(() => {
    request(BASEURL, UOMDetails).then((res) => setuomDropDown(res.allUom));
    request(BASEURL, brandDetails).then((res) =>
      setBrandDropDwon(res.allBrandDetail)
    );
  }, []);

  const navigate = useNavigate();
  const params = useLocation();

  const id1 = params.search.slice(1);
  useEffect(() => {
    if (id1) {
      fetchviewValue();
    }
  }, [id1]);

  const fetchviewValue = async () => {
    try {
      const res = await request(BASEURL, getWarehousedetail, {
        id: id1,
      });

      const v = res.getWarehousedetail;
      setSelectedData(v);

      setWareHouseData({
        wareHouseName: v.warehouseName,
        category: {
          value: v.category,
          label: v.category,
        },
        addressLine1: v.addressLine1,
        addressLine2: v.addressLine2,
        country: v.country,
        state: v.State,
        city: v.city,
        zipCode: v.zipCode,
        supervisorName: {
          value: v.supervisorName,
          label: v.supervisorName,
        },
        supervisorNumber: v.supervisorNumber,
        wareHouseContactNumber: v.warehouseContactNumber,
        wareHouseCapacity: v.warehouseCapacity,
        capacityUOM: v.capacityUom,
        description: v.Description,
        brandName: {
          value: v.brand.id,
          label: v.brand.brandName,
        },
        warehouseCost: v.warehouseCost,
        sellingPrice: v.sellingPrice,
        SKU: v.SKU,
        uomName: {
          value: v.UOM.id,
          label: v.UOM.uomName,
        },
        reorderLevel: v.reorderLevel,
        Tax: v.Tax,
        HSNNumber: v.HSNNumber,
        previewURL: URL + "media/" + v?.warehouseImage.replace(" ", "%20"),

        // Uom Type Status
        reorderLevelStatus: "success",
        TaxStatus: "success",
        warehouseImageStatus: "success",
        SKUStatus: "success",
        uomNameStatus: "success",
        HSNNumberStatus: "success",
        sellingPriceStatus: "success",
        warehouseCostStatus: "success",
        brandNameStatus: "success",
        wareHouseNameStatus: "success",
        categoryStatus: "success",
        addressLine1Status: "success",
        addressLine2Status: "success",
        countryStatus: "success",
        stateStatus: "success",
        cityStatus: "success",
        zipCodeStatus: "success",
        supervisorNameStatus: "success",
        supervisorNumberStatus: "success",
        wareHouseContactNumberStatus: "success",
        wareHouseCapacityStatus: "success",
        capacityUOMStatus: "success",
        descriptionStatus: "success",
        warehouseImageStatus: "success",
      });
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const categoryOptions = [
    {
      id: 1,
      value: "Distribution Center",
    },
    {
      id: 2,
      value: "Storage Warehouse",
    },
    {
      id: 3,
      value: "Cold Storage Warehouse",
    },
  ];

  const handleWareHouseDataChange = (event, selectEvent) => {
    let wareHouseState = { ...wareHouseData };
    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "category":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              wareHouseState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              wareHouseState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "supervisorName":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              wareHouseState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
              supervisorData.filter((v, i) => {
                if (v.id == event?.value) {
                  wareHouseState["supervisorNumber"] = v.contactno;
                  wareHouseState["supervisorNumberStatus"] = "success";
                } else {
                  wareHouseState["supervisorNumber"] = "";
                  wareHouseState["supervisorNumberStatus"] = "unchecked";
                }
              });
            } else {
              wareHouseState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
              wareHouseState["supervisorNumber"] = "";
              wareHouseState["supervisorNumberStatus"] = "unchecked";
            }
          }
          break;
        case "brandName":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              wareHouseState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              wareHouseState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "uomName":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              wareHouseState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              wareHouseState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      wareHouseState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "wareHouseName":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{2,20})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "addressLine1":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9.,/:]{1,50})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "addressLine2":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9.,/:]{1,50})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "country":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,30})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "state":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,30})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "city":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,30})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "zipCode":
          {
            const alphaNLenghthRegex = new RegExp("^([ A-Za-z0-9]{6})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "supervisorNumber":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9 ]{10})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "wareHouseContactNumber":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{10})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "wareHouseCapacity":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{1,6})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "capacityUOM":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9]{1,40})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "warehouseCost":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{1,6})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "sellingPrice":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{1,6})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "SKU":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9]{1,25})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "HSNNumber":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9]{1,25})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "reorderLevel":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{1,3})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "Tax":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{2})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "description":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 .]{1,200})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              wareHouseState[event.target.name + "Status"] = "success";
            } else {
              wareHouseState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      wareHouseState[event.target.name] = event.target.value;
    }

    setWareHouseData(wareHouseState);
  };

  const handleWareHouseImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        setWareHouseData({
          ...wareHouseData,
          warehouseImage: file,
          warehouseImageStatus: "success",
          previewURL: reader.result,
        });
        //   setImageURL(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setWareHouseData({
        ...wareHouseData,
        warehouseImage: "",
        warehouseImageStatus: "unchecked",
        previewURL: "",
      });
    }
  };

  const fetchData = () => {
    request(BASEURL, GetUserDetailsQuery, { id: currentUser?.id }).then(
      (res) => {
        setSupervisorData(res.getUserDetailByMaster);
      }
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      wareHouseData.wareHouseCapacityStatus === "success" &&
      wareHouseData.categoryStatus === "success" &&
      wareHouseData.addressLine1Status === "success" &&
      wareHouseData.countryStatus === "success" &&
      wareHouseData.stateStatus === "success" &&
      wareHouseData.cityStatus === "success" &&
      wareHouseData.zipCodeStatus === "success" &&
      wareHouseData.supervisorNameStatus === "success" &&
      wareHouseData.wareHouseContactNumberStatus === "success" &&
      wareHouseData.wareHouseCapacityStatus === "success" &&
      wareHouseData.capacityUOMStatus === "success" &&
      wareHouseData.brandNameStatus === "success" &&
      wareHouseData.warehouseCostStatus === "success" &&
      wareHouseData.sellingPriceStatus === "success" &&
      wareHouseData.SKUStatus === "success" &&
      (wareHouseData.HSNNumberStatus === "success" ||
        wareHouseData.HSNNumberStatus === "unchecked") &&
      wareHouseData.TaxStatus === "success" &&
      wareHouseData.uomNameStatus === "success" &&
      wareHouseData.addressLine2Status === "success" &&
      (wareHouseData.descriptionStatus === "success" ||
        wareHouseData.descriptionStatus === "unchecked") &&
      (wareHouseData.reorderLevelStatus === "success" ||
        wareHouseData.reorderLevelStatus === "unchecked")
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAddWareHouseData = async () => {
    const formData = new FormData();
    formData.append("user", rawPk);
    formData.append("warehouse_name", wareHouseData.wareHouseName);
    formData.append("category", wareHouseData.category?.label);
    formData.append("address_Line1", wareHouseData.addressLine1);
    formData.append("address_Line2", wareHouseData.addressLine2);
    formData.append("country", wareHouseData.country);
    formData.append("State", wareHouseData.state);
    formData.append("city", wareHouseData.city);
    formData.append("zip_code", wareHouseData.zipCode);
    formData.append("supervisor_name", wareHouseData.supervisorName?.label);
    formData.append("supervisor_number", wareHouseData.supervisorNumber);
    formData.append(
      "warehouse_contact_number",
      wareHouseData.wareHouseContactNumber
    );
    formData.append("warehouse_capacity", wareHouseData.wareHouseCapacity);
    formData.append("capacity_UOM", wareHouseData.capacityUOM);
    formData.append("brand", wareHouseData.brandName?.value);
    formData.append("warehouse_cost", wareHouseData.warehouseCost);
    formData.append("selling_price", wareHouseData.sellingPrice);
    formData.append("SKU", wareHouseData.SKU);
    formData.append("HSN_number", wareHouseData.HSNNumber);
    formData.append("UOM", wareHouseData.uomName?.value);
    formData.append("reorder_level", wareHouseData.reorderLevel);
    formData.append("Tax", wareHouseData.Tax);
    formData.append("Description", wareHouseData.description);
    if (wareHouseData.warehouseImage.name) {
      formData.append("warehouse_image", wareHouseData.warehouseImage);
    }
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const values = {
        //   user: rawPk,
        //   warehouseName: wareHouseData.wareHouseName,
        //   category: wareHouseData.category?.label,
        //   addressLine1: wareHouseData.addressLine1,
        //   addressLine2: wareHouseData.addressLine2,
        //   country: wareHouseData.country,
        //   State: wareHouseData.state,
        //   city: wareHouseData.city,
        //   zipCode: wareHouseData.zipCode,
        //   supervisorName: wareHouseData.supervisorName?.label,
        //   supervisorNumber: wareHouseData.supervisorNumber,
        //   warehouseContactNumber: wareHouseData.wareHouseContactNumber,
        //   warehouseCapacity: wareHouseData.wareHouseCapacity,
        //   capacityUom: wareHouseData.capacityUOM,
        //   brand: wareHouseData.brandName?.value,
        //   warehouseCost: wareHouseData.warehouseCost,
        //   sellingPrice: wareHouseData.sellingPrice,
        //   SKU: wareHouseData.SKU,
        //   HSNNumber: wareHouseData.HSNNumber,
        //   UOM: wareHouseData.uomName?.value,
        //   reorderLevel: wareHouseData.reorderLevel,
        //   Tax: wareHouseData.Tax,
        //   warehouseImage: "Brand logo/tree_ksGLsNS.jpg",
        //   Description: wareHouseData.description,
        // };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const status = await addWarehouseRestService(formData);
        setCirleLoading(false);
        if (status) {
          setSuccessStatus(true);
          setSucessTitle("Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/warehouse");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },

      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handledeleteWareData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your detail.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setPendingLoading(true);
        const delteStatus = await DeleteWareHouseService(id1);
        if (delteStatus) {
          setSuccessStatus(true);
          setSucessTitle("Deleted");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/warehouse");
          }, 1000);
        } else if (!delteStatus) {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setWareHouseData({
      wareHouseName: selectedData.warehouseName,
      category: {
        value: selectedData.category,
        label: selectedData.category,
      },
      addressLine1: selectedData.addressLine1,
      addressLine2: selectedData.addressLine2,
      country: selectedData.country,
      state: selectedData.State,
      city: selectedData.city,
      zipCode: selectedData.zipCode,
      supervisorName: {
        value: selectedData.supervisorName,
        label: selectedData.supervisorName,
      },
      supervisorNumber: selectedData.supervisorNumber,
      wareHouseContactNumber: selectedData.warehouseContactNumber,
      wareHouseCapacity: selectedData.warehouseCapacity,
      capacityUOM: selectedData.capacityUom,
      description: selectedData.Description,
      brandName: {
        value: selectedData.brand.id,
        label: selectedData.brand.brandName,
      },
      warehouseCost: selectedData.warehouseCost,
      sellingPrice: selectedData.sellingPrice,
      SKU: selectedData.SKU,
      uomName: {
        value: selectedData.UOM.id,
        label: selectedData.UOM.uomName,
      },
      reorderLevel: selectedData.reorderLevel,
      Tax: selectedData.Tax,
      HSNNumber: selectedData.HSNNumber,

      // Uom Type Status
      reorderLevelStatus: "success",
      TaxStatus: "success",
      warehouseImageStatus: "success",
      SKUStatus: "success",
      uomNameStatus: "success",
      HSNNumberStatus: "success",
      sellingPriceStatus: "success",
      warehouseCostStatus: "success",
      brandNameStatus: "success",
      wareHouseNameStatus: "success",
      categoryStatus: "success",
      addressLine1Status: "success",
      addressLine2Status: "success",
      countryStatus: "success",
      stateStatus: "success",
      cityStatus: "success",
      zipCodeStatus: "success",
      supervisorNameStatus: "success",
      supervisorNumberStatus: "success",
      wareHouseContactNumberStatus: "success",
      wareHouseCapacityStatus: "success",
      capacityUOMStatus: "success",
      descriptionStatus: "success",
      warehouseImageStatus: "success",
    });
  };
  const handleCancelWareData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const delteStatus = await deleteBrandService(id);
        // if (delteStatus) {
        navigate("/warehouse");
        // } else if (!delteStatus) {
        // }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const handleEditWareHouseData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        // const values = {
        //   warehouseName: wareHouseData.wareHouseName,
        //   category: wareHouseData.category?.label,
        //   addressLine1: wareHouseData.addressLine1,
        //   addressLine2: wareHouseData.addressLine2,
        //   country: wareHouseData.country,
        //   State: wareHouseData.state,
        //   city: wareHouseData.city,
        //   zipCode: wareHouseData.zipCode,
        //   supervisorName: wareHouseData.supervisorName?.label,
        //   supervisorNumber: wareHouseData.supervisorNumber,
        //   warehouseContactNumber: wareHouseData.wareHouseContactNumber,
        //   warehouseCapacity: wareHouseData.wareHouseCapacity,
        //   capacityUom: wareHouseData.capacityUOM,
        //   brand: wareHouseData.brandName?.value,
        //   warehouseCost: wareHouseData.warehouseCost,
        //   sellingPrice: wareHouseData.sellingPrice,
        //   SKU: wareHouseData.SKU,
        //   HSNNumber: wareHouseData.HSNNumber,
        //   UOM: wareHouseData.uomName?.value,
        //   reorderLevel: wareHouseData.reorderLevel,
        //   Tax: wareHouseData.Tax,
        //   warehouseImage: "Brand logo/tree_ksGLsNS.jpg",
        //   Description: wareHouseData.description,
        // };
        // const updateStatus = await updateWarehouseService(values, id1);
        const formData = new FormData();
        formData.append("user", rawPk);
        // if (values.masterid) {
        //   formData.append('master_id', wareHouseData.masterid)
        // }
        formData.append("warehouse_name", wareHouseData.wareHouseName);
        formData.append("category", wareHouseData.category?.label);
        formData.append("address_Line1", wareHouseData.addressLine1);
        formData.append("address_Line2", wareHouseData.addressLine2);
        formData.append("country", wareHouseData.country);
        formData.append("State", wareHouseData.state);
        formData.append("city", wareHouseData.city);
        formData.append("zip_code", wareHouseData.zipCode);
        formData.append("supervisor_name", wareHouseData.supervisorName?.label);
        formData.append("supervisor_number", wareHouseData.supervisorNumber);
        formData.append(
          "warehouse_contact_number",
          wareHouseData.wareHouseContactNumber
        );
        formData.append("warehouse_capacity", wareHouseData.wareHouseCapacity);
        formData.append("capacity_UOM", wareHouseData.capacityUOM);
        formData.append("brand", wareHouseData.brandName?.value);
        formData.append("warehouse_cost", wareHouseData.warehouseCost);
        formData.append("selling_price", wareHouseData.sellingPrice);
        formData.append("SKU", wareHouseData.SKU);
        formData.append("HSN_number", wareHouseData.HSNNumber);
        formData.append("UOM", wareHouseData.uomName?.value);
        formData.append("reorder_level", wareHouseData.reorderLevel);
        formData.append("Tax", wareHouseData.Tax);
        formData.append("Description", wareHouseData.description);
        if (wareHouseData.warehouseImage) {
          formData.append("warehouse_image", wareHouseData.warehouseImage);
        }
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const updateStatus = await updateWarehouseRestService(formData, id1);
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/warehouse");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <SuccessPop title={""} />
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true || togglePage.edit === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Warehouse details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                    size="small"
                  >
                    <MaterialButton
                      variant="contained"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="contained"
                      color="dark"
                      onClick={handledeleteWareData}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add WareHouse Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
           <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
              <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
              <MaterialTypography
              sx={{color:'#460058',fontFamily:'Aptos'}}
                component="label"
                variant="body2"
                fontWeight="700"
              >
                Warehouse Information
              </MaterialTypography>
            </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    WareHouse Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="wareHouseName"
                  placeholder="Enter WareHouse Name"
                  size="small"
                  value={wareHouseData.wareHouseName}
                  onChange={handleWareHouseDataChange}
                  error={
                    wareHouseData.wareHouseNameStatus === "error" ? true : false
                  }
                  success={
                    wareHouseData.wareHouseNameStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.wareHouseNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      WareHouse Name should be maximum 20 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    WareHouse Category <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="category"
                  size="small"
                  value={wareHouseData.category}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleWareHouseDataChange} //selectedValue, event
                  options={categoryOptions?.map((option) => {
                    return {
                      value: option.id,
                      label: option.value,
                    };
                  })}
                  isDisabled={togglePage?.view === true ? true : false}
                  error={
                    wareHouseData.categoryStatus === "error" ? true : false
                  }
                  success={
                    wareHouseData.categoryStatus === "success" ? true : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Address Line1 <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="addressLine1"
                  placeholder="Enter WareHouse Address"
                  size="small"
                  value={wareHouseData.addressLine1}
                  onChange={handleWareHouseDataChange}
                  error={
                    wareHouseData.addressLine1Status === "error" ? true : false
                  }
                  success={
                    wareHouseData.addressLine1Status === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.addressLine1Status === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Enter a Valid Address and allows maximum 50 characters
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Address Line2 <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="addressLine2"
                  placeholder="Enter WareHouse Address"
                  size="small"
                  value={wareHouseData.addressLine2}
                  onChange={handleWareHouseDataChange}
                  error={
                    wareHouseData.addressLine2Status === "error" ? true : false
                  }
                  success={
                    wareHouseData.addressLine2Status === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.addressLine2Status === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Enter a Valid Address and allows maximum 50 characters
                      long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Country <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="country"
                  placeholder="Enter Country"
                  size="small"
                  value={wareHouseData.country}
                  onChange={handleWareHouseDataChange}
                  error={wareHouseData.countryStatus === "error" ? true : false}
                  success={
                    wareHouseData.countryStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.countryStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Enter a Valid Country and allows maximum 30 characters
                      long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    State <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="state"
                  placeholder="Enter State"
                  size="small"
                  value={wareHouseData.state}
                  onChange={handleWareHouseDataChange}
                  error={wareHouseData.stateStatus === "error" ? true : false}
                  success={
                    wareHouseData.stateStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.stateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Enter a Valid State and allows maximum 30 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    City <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="city"
                  placeholder="Enter City"
                  size="small"
                  value={wareHouseData.city}
                  onChange={handleWareHouseDataChange}
                  error={wareHouseData.cityStatus === "error" ? true : false}
                  success={
                    wareHouseData.cityStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.cityStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Enter a Valid City and allows maximum 30 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Zip Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="zipCode"
                  placeholder="Enter ZipCode"
                  size="small"
                  value={wareHouseData.zipCode}
                  onChange={handleWareHouseDataChange}
                  error={wareHouseData.zipCodeStatus === "error" ? true : false}
                  success={
                    wareHouseData.zipCodeStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.zipCodeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Zip Code should be maximum 6 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Supervisor Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="supervisorName"
                  value={wareHouseData.supervisorName}
                  size="small"
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleWareHouseDataChange} //selectedValue, event
                  options={supervisorData?.map((option) => {
                    return {
                      value: option.id,
                      label: option.username,
                    };
                  })}
                  error={
                    wareHouseData.supervisorNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    wareHouseData.supervisorNameStatus === "success"
                      ? true
                      : false
                  }
                  isDisabled={togglePage?.view === true ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Supervisor Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="supervisorNumber"
                  type="number"
                  placeholder="eg. 98840*****"
                  size="small"
                  value={wareHouseData.supervisorNumber}
                  onChange={handleWareHouseDataChange}
                  error={
                    wareHouseData.supervisorNumberStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    wareHouseData.supervisorNumberStatus === "success"
                      ? true
                      : false
                  }
                  disabled={true}
                />
                {wareHouseData.supervisorNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Supervisor Number should be maximum 10 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    WareHouse Contact Number{" "}
                    <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="wareHouseContactNumber"
                  type="number"
                  placeholder="eg. 98840*****"
                  size="small"
                  value={wareHouseData.wareHouseContactNumber}
                  onChange={handleWareHouseDataChange}
                  error={
                    wareHouseData.wareHouseContactNumberStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    wareHouseData.wareHouseContactNumberStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.wareHouseContactNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      WareHouse Contact Number should be maximum 10 characters
                      long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    WareHouse Capacity <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="wareHouseCapacity"
                  type="number"
                  size="small"
                  placeholder="Enter WareHouse Capacity"
                  value={wareHouseData.wareHouseCapacity}
                  onChange={handleWareHouseDataChange}
                  error={
                    wareHouseData.wareHouseCapacityStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    wareHouseData.wareHouseCapacityStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.wareHouseCapacityStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      WareHouse Capacity should be allows maximum 6 characters
                      long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Capacity UOM <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="capacityUOM"
                  type="text"
                  size="small"
                  placeholder="Enter Capacity UOM"
                  value={wareHouseData.capacityUOM}
                  onChange={handleWareHouseDataChange}
                  error={
                    wareHouseData.capacityUOMStatus === "error" ? true : false
                  }
                  success={
                    wareHouseData.capacityUOMStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Brand Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="brandName"
                  size="small"
                  value={wareHouseData.brandName}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleWareHouseDataChange} //selectedValue, event
                  options={brandDropDown?.map((option) => {
                    return {
                      value: option.id,
                      label: option.brandName,
                    };
                  })}
                  error={
                    wareHouseData.brandNameStatus === "error" ? true : false
                  }
                  success={
                    wareHouseData.brandNameStatus === "success" ? true : false
                  }
                  isDisabled={togglePage?.view === true ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Warehouse Cost <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="warehouseCost"
                  type="number"
                  size="small"
                  placeholder="Enter WareHouse Cost"
                  value={wareHouseData.warehouseCost}
                  onChange={handleWareHouseDataChange}
                  error={
                    wareHouseData.warehouseCostStatus === "error" ? true : false
                  }
                  success={
                    wareHouseData.warehouseCostStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.warehouseCostStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      WareHouse Capacity should be allows maximum 6 characters
                      long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Selling Price <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="sellingPrice"
                  type="number"
                  size="small"
                  placeholder="Enter Selling Price"
                  value={wareHouseData.sellingPrice}
                  onChange={handleWareHouseDataChange}
                  error={
                    wareHouseData.sellingPriceStatus === "error" ? true : false
                  }
                  success={
                    wareHouseData.sellingPriceStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.sellingPriceStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Selling Price should be allows maximum 6 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    SKU <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="SKU"
                  size="small"
                  type="text"
                  placeholder="Enter SKU Capacity"
                  value={wareHouseData.SKU}
                  onChange={handleWareHouseDataChange}
                  disabled={togglePage?.view === true ? true : false}
                  error={wareHouseData.SKUStatus === "error" ? true : false}
                  success={wareHouseData.SKUStatus === "success" ? true : false}
                />
                {wareHouseData.SKUStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      SKU Number should be allows maximum 25 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    HSN Number
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="HSNNumber"
                  type="text"
                  size="small"
                  placeholder="Enter HSN Number"
                  value={wareHouseData.HSNNumber}
                  onChange={handleWareHouseDataChange}
                  error={
                    wareHouseData.HSNNumberStatus === "error" ? true : false
                  }
                  success={
                    wareHouseData.HSNNumberStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.HSNNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      HSN Number should be allows maximum 25 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"                  >
                    Uom <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="uomName"
                  size="small"
                  value={wareHouseData.uomName}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleWareHouseDataChange} //selectedValue, event
                  options={uomDropDown?.map((option) => {
                    return {
                      value: option.id,
                      label: option.uomName,
                    };
                  })}
                  isDisabled={togglePage?.view === true ? true : false}
                  error={wareHouseData.uomNameStatus === "error" ? true : false}
                  success={
                    wareHouseData.uomNameStatus === "success" ? true : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Reorder level
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="reorderLevel"
                  type="number"
                  size="small"
                  placeholder="Enter Reorder Level"
                  value={wareHouseData.reorderLevel}
                  onChange={handleWareHouseDataChange}
                  error={
                    wareHouseData.reorderLevelStatus === "error" ? true : false
                  }
                  success={
                    wareHouseData.reorderLevelStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {wareHouseData.reorderLevelStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Reorder Level should be allows maximum 3 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              {/* <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Location/warehouse <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="category"
                  value={wareHouseData.category}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleWareHouseDataChange} //selectedValue, event
                  options={categoryOptions?.map((option) => {
                    return {
                      value: option.id,
                      label: option.value,
                    };
                  })}
                  error={
                    wareHouseData.categoryStatus === "error" ? true : false
                  }
                  success={
                    wareHouseData.categoryStatus === "success" ? true : false
                  }
                  isClearable
                />
              </Grid> */}
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Tax<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="Tax"
                  type="number"
                  placeholder="Enter Tax"
                  size="small"
                  value={wareHouseData.Tax}
                  onChange={handleWareHouseDataChange}
                  error={wareHouseData.TaxStatus === "error" ? true : false}
                  disabled={togglePage?.view === true ? true : false}
                  success={wareHouseData.TaxStatus === "success" ? true : false}
                />
                {wareHouseData.TaxStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Tax should be allows maximum 2 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Warehouse Image
                  </MaterialTypography>
                </MaterialBox>
                {togglePage?.view === true ? null : (
                  <MaterialInput
                    name="warehouseImage"
                    type="file"
                    size="small"
                    placeholder="Enter WareHouse Capacity"
                    // value={wareHouseData.warehouseImage}
                    onChange={handleWareHouseImageChange}
                    error={
                      wareHouseData.warehouseImageStatus === "error"
                        ? true
                        : false
                    }
                    success={
                      wareHouseData.warehouseImageStatus === "success"
                        ? true
                        : false
                    }
                    disabled={togglePage?.view === true ? true : false}
                  />
                )}

                {wareHouseData.previewURL && (
                  <MaterialBox mt={2}>
                    <img
                      src={wareHouseData.previewURL}
                      alt="Brand Logo Preview"
                      width="100"
                    />
                  </MaterialBox>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Description
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="description"
                  size="small"
                  placeholder="Write Description..."
                  value={wareHouseData.description}
                  onChange={handleWareHouseDataChange}
                  error={
                    wareHouseData.descriptionStatus === "error" ? true : false
                  }
                  success={
                    wareHouseData.descriptionStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                  multiline
                  rows={3}
                />
                {wareHouseData.descriptionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      description should be allows maximum 200 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            mt={3}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {togglePage.edit === true ? (
              <>
                <MaterialButton
                  sx={{ m: 1 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={handleDiscardButton}
                >
                  Discard
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 1 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  disabled={!checkAllFields()}
                  onClick={handleEditWareHouseData}
                >
                  Update
                </MaterialButton>
              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <>
                <MaterialButton
                  sx={{ m: 1 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={handleCancelWareData}
                >
                  Cancel
                </MaterialButton>
                  <MaterialButton
                  sx={{ m: 1 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  disabled={!checkAllFields()}
                  onClick={handleAddWareHouseData}
                >
                  Submit
                </MaterialButton>
              </>
            ) : null}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
